export default {"src":"/_next/static/media/paris-je-taime-logo.aff61c1c.svg","height":1701,"width":1701,"blurWidth":0,"blurHeight":0};